var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEBay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 32,
    viewBox: "0 0 51 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eBay"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    width: 50,
    height: 32,
    rx: 3,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M11.4137 11.709C8.73345 11.709 6.5 12.8461 6.5 16.2766C6.5 18.9944 8.00183 20.7059 11.4829 20.7059C15.5803 20.7059 15.8429 18.0068 15.8429 18.0068H13.8576C13.8576 18.0068 13.4319 19.4602 11.3618 19.4602C9.67575 19.4602 8.46309 18.3212 8.46309 16.7248H16.0506V15.723C16.0506 14.1436 15.0479 11.709 11.4137 11.709ZM11.3445 12.9893C12.9494 12.9893 14.0436 13.9725 14.0436 15.4462H8.507C8.507 13.8817 9.93513 12.9893 11.3445 12.9893Z",
    fill: "#E53238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M16.0488 8.38672V18.9827C16.0488 19.5842 16.0059 20.4287 16.0059 20.4287H17.8995C17.8995 20.4287 17.9675 19.8222 17.9675 19.2678C17.9675 19.2678 18.903 20.7315 21.4469 20.7315C24.1258 20.7315 25.9454 18.8717 25.9454 16.2071C25.9454 13.7283 24.274 11.7346 21.4513 11.7346C18.808 11.7346 17.9866 13.162 17.9866 13.162V8.38672H16.0488ZM20.9625 13.0452C22.7816 13.0452 23.9384 14.3953 23.9384 16.2071C23.9384 18.1499 22.6023 19.4209 20.9755 19.4209C19.0339 19.4209 17.9866 17.9049 17.9866 16.2244C17.9866 14.6585 18.9264 13.0452 20.9625 13.0452Z",
    fill: "#0064D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M30.652 11.709C26.6197 11.709 26.3611 13.9168 26.3611 14.2696H28.3681C28.3681 14.2696 28.4734 12.9807 30.5136 12.9807C31.8393 12.9807 32.8666 13.5875 32.8666 14.7541V15.1693H30.5136C27.3897 15.1693 25.7383 16.0832 25.7383 17.9376C25.7383 19.7626 27.2642 20.7556 29.3262 20.7556C32.1365 20.7556 33.0418 19.2028 33.0418 19.2028C33.0418 19.8204 33.0894 20.4291 33.0894 20.4291H34.8736C34.8736 20.4291 34.8044 19.6746 34.8044 19.192V15.0201C34.8044 12.2847 32.598 11.709 30.652 11.709ZM32.8666 16.4151V16.9687C32.8666 17.6908 32.421 19.4861 29.7977 19.4861C28.3612 19.4861 27.7453 18.7692 27.7453 17.9376C27.7453 16.4248 29.8194 16.4151 32.8666 16.4151Z",
    fill: "#F5AF02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M33.7227 12.0547H35.9805L39.2209 18.5465L42.4539 12.0547H44.4992L38.6104 23.6122H36.465L38.1643 20.3904L33.7227 12.0547Z",
    fill: "#86B817"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEBay);
export default __webpack_public_path__ + "static/media/e-bay.fdabca5c4984a8fe08852c4815bf57dc.svg";
export { ForwardRef as ReactComponent };